var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_405_12187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.39999 3.05C1.10044 3.05 0.0499878 4.10046 0.0499878 5.4V18.2C0.0499878 19.4996 1.10044 20.55 2.39999 20.55H21.6C22.8995 20.55 23.95 19.4996 23.95 18.2V5.4C23.95 4.10046 22.8995 3.05 21.6 3.05H2.39999Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_405_12187",
    maskUnits: "userSpaceOnUse",
    x: -0.837341,
    y: 2.38667,
    width: 26,
    height: 11,
    fill: "black",
    className: "fill-also",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    stroke: "none",
    className: "fill-also",
    x: -0.837341,
    y: 2.38667,
    width: 26,
    height: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8373 4.38667L14.1547 11.064C12.8853 12.0347 11.1253 12.0347 9.85599 11.064L1.16266 4.38667"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.7517 5.57572C24.4084 5.07069 24.5314 4.12894 24.0264 3.47225C23.5213 2.81556 22.5796 2.69261 21.9229 3.19763L23.7517 5.57572ZM14.1547 11.064L15.0658 12.2555L15.0691 12.2531L14.1547 11.064ZM9.85599 11.064L8.94227 12.2536L8.94482 12.2555L9.85599 11.064ZM2.07638 3.19709C1.41939 2.69245 0.477705 2.81596 -0.0269281 3.47295C-0.531561 4.12994 -0.408051 5.07163 0.248939 5.57626L2.07638 3.19709ZM21.9229 3.19763L13.2402 9.87496L15.0691 12.2531L23.7517 5.57572L21.9229 3.19763ZM13.2435 9.87247C12.512 10.4319 11.4987 10.4319 10.7672 9.87247L8.94482 12.2555C10.752 13.6375 13.2587 13.6375 15.0658 12.2555L13.2435 9.87247ZM10.7697 9.87442L2.07638 3.19709L0.248939 5.57626L8.94227 12.2536L10.7697 9.87442Z",
    fill: "#031D3C",
    className: "fill-also",
    stroke: "none",
    mask: "url(#path-4-outside-1_405_12187)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 3.75,
    width: 22.5,
    height: 16.1,
    rx: 1.25,
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_405_12187"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 24,
    height: 17.6,
    rx: 2,
    fill: "white",
    className: "fill-also",
    stroke: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.56b77d4263a2c8dfbde1eafadcadca43.svg";
export { ForwardRef as ReactComponent };